import { render, staticRenderFns } from "./booklist.vue?vue&type=template&id=ba78fb2a&scoped=true&"
import script from "./booklist.vue?vue&type=script&lang=js&"
export * from "./booklist.vue?vue&type=script&lang=js&"
import style0 from "./booklist.vue?vue&type=style&index=0&id=ba78fb2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba78fb2a",
  null
  
)

export default component.exports